import { defineMessages } from 'react-intl';

export const headlineMessages = defineMessages({
  title: {
    id: 'oauth.shared.headline.redirectHost',
    defaultMessage:
      '{requestingParty} is requesting access to your {product} account',
    description:
      'Consent headline shown at the top of the page; {requestingParty} is the app or host name',
  },
});
